import { connect } from 'react-redux'
import TableView from '../../../../common/containers/TableView'
import { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { Link, useSearchParams } from 'react-router-dom'
import { callCheckListGet } from '../../actions/checks'

let CheckList = ({ setPageAttr, list, methods: { callCheckListGet } }) => {
    let [searchParams] = useSearchParams();

    const headers = [
        {
            type: 'info',
            name: 'id',
            align: 'right',
            label: 'ID'
        },
        {
            type: 'datetime',
            name: 'createdAt',
            align: 'left',
            label: 'Turno'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <Link to={'/checks/detail/' + a.id} className='btn btn-sm btn-primary'><i className='fas fa-eye'></i></Link>
                )
            }
        }
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callCheckListGet({}, pg)
    }, [callCheckListGet, searchParams])

    useEffect(() => {
        setPageAttr({
            title: 'Relatório de Checagem',
            caption: 'Informações dos checks realizados por data de turno.',
            btns: [],
            tabs: [
                {
                    active: true,
                    to: '/checks',
                    label: 'Informações'
                }
            ]
        })
    }, [setPageAttr])

    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/checks-initialize'} />
    )
}

const mapStateToProps = ({ check: { check: { list } } }) => ({
    list: list,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callCheckListGet,
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckList)